import { render, staticRenderFns } from "./DataTableComponent.vue?vue&type=template&id=e9f05570&"
import script from "./DataTableComponent.controller.js?vue&type=script&lang=js&"
export * from "./DataTableComponent.controller.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Projects/Hugo/Ilead/FrontEnd/lbcleadership/Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDataTable,VFlex,VLayout})
